import { ExceptionEvent, ExceptionEventState } from "@fairfleet/geotab";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircle from "@mui/icons-material/CheckCircle";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import formatDuration from "../../cells/formatDuration";
import CommentSection from "../CommentSection";
import { useGeotabClient } from "@/components/GeotabClientContext";
import { useUpdateExceptionEvent } from "@/hooks/exceptionEvent/useUpdateExceptionEvent";
import isDemo from "@/utilities/isDemo";

interface Props {
  event: ExceptionEvent;
  title: string;
  color: "error" | "warning" | "primary";
}

export default function TellTaleWarningDetails(props: Props) {
  const { event, title, color } = props;
  const { geotabClient } = useGeotabClient();
  const updateEvent = useUpdateExceptionEvent();

  const handleUpdateEventState = () => {
    updateEvent.mutate({
      geotabClient,
      entity: {
        ...event,
        state: ((event.state as unknown as string) === "ExceptionEventStateValidId"
          ? "ExceptionEventStateDismissedId"
          : "ExceptionEventStateValidId") as unknown as ExceptionEventState,
      },
    });
    // Just to show the loading indicator
    event.state = "loading" as unknown as ExceptionEventState;
  };



  const { t } = useTranslation();
  return (
    <Box>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <ReportProblemIcon color={color} />
        <Typography variant="h6" sx={{ ml: 1 }}>
          {title}
        </Typography>
        <Tooltip
          title={
            isDemo
              ? "Demo"
              : (event?.state as unknown as string) === "loading"
                ? t("faultOverview.loading")
                : (event?.state as unknown as string) === "ExceptionEventStateValidId"
                  ? t("faultOverview.dismissEvent")
                  : t("faultOverview.validateEvent")
          }
        >
          <IconButton
            onClick={handleUpdateEventState}
            disabled={isDemo || (event?.state as unknown as string) === "loading"}
            sx={{ ml: 1 }}
          >
            {(event?.state as unknown as string) === "loading" ? (
              <CircularProgress />
            ) : (event?.state as unknown as string) === "ExceptionEventStateValidId" ? (
              <CancelIcon color="error" />
            ) : (
              <CheckCircle color="success" />
            )}
          </IconButton>
        </Tooltip>
      </Box>
      <Typography>
        {t("faultOverview.since") + " "}
        {formatDuration(event.duration, true)}
      </Typography>
      <CommentSection event={event} />
    </Box>
  );
}
